<template>
 <div class="flex" style="flex-direction: row; align-items: center;">
        <h2>Audio</h2>
        <div @click="showAddMediaPropertyModal = true"  :style="allowEdit ? '' : 'display: none;'" class="openModalButton" style="color: #036991; cursor: pointer;margin-left: 20px;">
            <i class="fa-circle-plus fas fa-2xl"></i>
        </div>
    </div>
    <div class="row row-header" v-if="audioActions.length > 0" >
        <div class="grip" style="flex:0 0 18px"></div>
        <div class="column-1x" style="align-items: flex-start;">Type</div>
        <div class="column-2x" style="align-items: flex-start;">Description</div>
        <div class="column-2x conditionalJson" style="align-items: flex-start;">Display Conditions</div>
        <div class="column-1x" style="align-items: flex-start;">Pause Time After(ms)</div>
        <div style="width: 30px; border-right:none;"></div>
    </div>
    <VueDraggableNext class="dragArea list-group w-full" style="padding: 0px; width:100%;" :list="audioActions" @update="moveAction" :disabled="!allowEdit" v-if="audioActions.length > 0">
        <div class="row row-data" v-for="(action, actIndex) in audioActions" :key="actIndex">
            <div class="grip">
                <i class="fa-solid fa-grip-vertical"></i>
            </div>
            <div class="column-1x">
                {{ action.subType }}
            </div>
            <div class="column-2x">
                <a :href="'/MediaPropertyEdit?ID=' + action.configuration.mediaPropertyID">
                    {{ action.configuration.mediaProperty.description }}&nbsp;&nbsp; 
                <i class="fa-solid fa-arrow-up-right-from-square" style="color:#036991;"></i></a>              
            </div>
            <div class="conditionalJson column-2x" style="align-items: flex-start; padding-top: 2px;">
                <i @click="showConditionalModal(action, 'action')" class="fa-pen-to-square fas fa-lg editConditions" :style="allowEdit ? '' : 'display: none'"></i>
                <div v-html="getPrintConditions( action.conditionalJson )"></div>
            </div>
            <div class="column-1x">
                {{ action.configuration.mediaProperty.configuration.millisecondsBeforeNextAudio}}
            </div>
            <div class="deleteButtonColumn">
                <div  @click="deleteAction (action)" :style="allowEdit ? '' : 'display: none'">
                    <i class="fas fa-lg fa-trash-can"></i>
                </div>
            </div>
        </div>
    </VueDraggableNext>
    <ConditionalExpressionModal :conditions="conditionGroup" v-if="ExpressionModalVisible" @close="ExpressionModalVisible=false" 
            :onConditionsChanged="updateConditions"></ConditionalExpressionModal>
    <AddAudioActionModal v-if="this.showAddMediaPropertyModal" @saveMediaProperty="saveMediaProperty" @hideAddMediaPropertyModal="this.showAddMediaPropertyModal = false" :object="action" mediaTypeFilter="Audio"></AddAudioActionModal>
</template>

<script>
import {data} from '../../shared/data';
import { VueDraggableNext} from 'vue-draggable-next';
import ConditionalExpressionModal from '@/components/shared/ConditionalExpressions/ConditionalExpressionModal.vue';
import AddAudioActionModal from '@/components/mediaproperty/AddAudioActionModal.vue';
import { printConditions } from '@/shared/logicProcessing';

export default {
    name: 'AudioListing',
    components: { AddAudioActionModal, VueDraggableNext,  ConditionalExpressionModal  },
    data: function() {
        return { 
            audioActions: [],
            activePage: null,
            logActivityTypes: [],
            modalKey: 0,
            questionTypes: [],
            activePageIndex: -1,
            initialLoad: true,
            ExpressionModalVisible: false,
            conditionalExpressionObject: null,
            ExpressionObjectType: '',
            conditionGroup: {},
            ACTION_TYPE: 3,
            showAddMediaPropertyModal: false
        };
    },  
    props: {
        objectType: {
            type: String,
            required: true,
            validator(value) {
                // The value must match one of these strings
                return ['SurveyAction', 'AccordionAction'].includes(value)
            }
        },
        allowEdit: {
            type: Boolean,
            required: true
        },
        // surveyID for SurveyActions, accordionID for AccordionActions
        grandParentID: {
            type: Number,
            required: true
        },
        // surveyPageID for SurveyActions, accordionSectionID for AccordionActions
        parentID: {
            type: Number,
            default: null
        },
        actions: {
            type: Object,
            default: null
        },
        onUpdate: {
            type: Function,
            default: null,
            required: true
        }
    },
    watch: {
        actions: function() { 
            this.setAudioActions();
        },
        parentID: function() {
            this.setAudioActions();
        }
    },
    computed: {
        active() {
            if(this.inputId != null)
                return "Edit";
            else
                return "Create New";
        },
        isSurveyAction() {
            return (this.objectType === 'SurveyAction');
        },
        isAccordionAction() {
            return (this.objectType === 'AccordionAction');
        }
    },
    async mounted() {
        this.setAudioActions();
    },
    methods: {
        setAudioActions: async function() {
            if(!this.actions.length)
                return;
            let audioActions;
            if(this.isSurveyAction) 
                audioActions = this.actions.filter((search) => this.isAudio(search) && search.configuration.surveyPageID === this.parentID);
            else if(this.isAccordionAction) 
                audioActions = this.actions.filter((search) => this.isAudio(search) && (this.parentID === null || search.accordionSectionID === this.parentID));

            for(var i = 0; i < audioActions.length; i++) {
                if(audioActions[i].configuration.mediaPropertyID) 
                    audioActions[i].configuration.mediaProperty = await data.getMediaProperty(audioActions[i].configuration.mediaPropertyID);
            }

            this.audioActions = this.sortActions(audioActions);
        },
        isAudio: function(action) {
            return (action.type === 'PlayAudio');
        },
        getPrintConditions: function(conditions) {
            if(conditions != undefined && conditions != '{}' && conditions != '')
                return printConditions(JSON.parse(conditions));
            else 
                return '';
        },
        showConditionalModal: function(object, type) {
            if(object.conditionalJson == null || object.conditionalJson == undefined)
                this.conditionGroup = {};
            else 
                this.conditionGroup = JSON.parse(object.conditionalJson);

            this.conditionalExpressionObject = object;
            this.ExpressionModalVisible = true;
            this.ExpressionObjectType = type;
        },
        updateConditions: function(conditionGroup) {
            this.conditionalExpressionObject.conditionalJson =  JSON.stringify(conditionGroup);
            this.saveAction(this.conditionalExpressionObject, 'conditionalJson');
        },
        moveAction: async function(evt) {
            if(evt) {
                var newSequence = 0;

                if(evt.newIndex == (this.audioActions.length - 1)) 
                    newSequence = this.audioActions[evt.newIndex - 1].sequence + 1;
                else if(evt.newIndex > 0)
                    newSequence = this.audioActions[evt.newIndex + 1].sequence;

                this.reorderActions(this.audioActions[evt.newIndex].sequence, newSequence);
            }
        },
        reorderActions: async function(oldSequence, newSequence) {
            let updatedActions;

            if(this.isSurveyAction)
                updatedActions = await data.reorderSurveyActions(this.grandParentID, this.parentID, 'PlayAudio', oldSequence, newSequence);
            else if(this.isAccordionAction)
                updatedActions = await data.reorderAccordionActions(this.grandParentID, this.parentID, 'PlayAudio', oldSequence, newSequence);

            var tmpActions = [];
            for(var x = 0; x < this.audioActions.length; x++) { 
                var found = updatedActions.find(search => search.id == this.audioActions[x].id);
              
                if(found != null) {
                    tmpActions.push(this.audioActions[x]);
                    tmpActions[tmpActions.length - 1].sequence = found.sequence;                        
                }
            }

            this.sortActions(tmpActions);
            this.audioActions = tmpActions;
            this.$toast.success('Saved');
        },
        sortActions: function(actions) {
            actions.sort((a,b) => {
                return a.sequence - b.sequence;
            });
            return actions;
        },
        saveAction: async function(action, fieldName) {
            let obj = {};
            if(fieldName) {
                obj.id = action.id;
                if(this.isSurveyAction)
                    obj.surveyId = this.grandParentID;
                else if(this.isAccordionAction)
                    obj.accordionID = this.grandParentID;
                obj[fieldName] = action[fieldName];
            }
             else {
                obj = action;
                if(this.isAccordionAction && !obj.accordionSectionID)
                    obj.accordionSectionID = 0;
            }

            let result;
            if(this.isSurveyAction)
                result = this.processSaveResult(await data.saveSurveyAction(obj));
            else if(this.isAccordionAction)
                result = this.processSaveResult(await data.saveAccordionAction(obj, this.grandParentID));
            
            if(result.success) {
                action.id = result.id;
                this.onUpdate(action);
            } 

            return result;
        },
        deleteAction: async function(action) {
            if(confirm('Are you sure you want to delete this audio?')) {
                let result;
                if(this.isSurveyAction)
                    result = this.processDeleteResult(await data.deleteSurveyAction(action));
                else if(this.isAccordionAction)
                    result = this.processDeleteResult(await data.deleteAccordionAction(action, this.grandParentID));
                if(result.success) {
                    var index = this.audioActions.findIndex(search => search.id == action.id);
                    this.audioActions.splice(index, 1);
                }
            }
        },
        saveConditionalJsonChanges: async function(jsonText, action) {
            action.conditionalJson = jsonText;
            await this.saveAction(action, 'conditionalJson');
        },
        saveMediaProperty: async function(mp) {
            let action = {
                type: 'PlayAudio',
                subType: 'AudioOnLoad',
                sequence: this.audioActions.length > 0 ? this.audioActions[this.audioActions.length - 1].sequence + 1 : 1
            }
            if(this.isSurveyAction) {
                action.surveyId = this.grandParentID;
                action.configuration = {
                    surveyPageID: this.parentID,
                    mediaPropertyID: mp.id
                }
            }
            else if(this.isAccordionAction) {
                action.accordionID = this.grandParentID;
                action.accordionSectionID = this.parentID ? this.parentID : null;
                action.configuration = {
                    mediaPropertyID: mp.id
                };
            }

            await this.saveAction(action);
        },  
    }
}
</script>

<style scoped>
    input, textarea {
        width: 100%;
    }

    .dragArea {
        display: flex; 
        flex-direction: row;
        padding: 5px;
        flex-wrap: wrap;
        padding-right: 40px;
    }

    .flex {
        display: flex;
        width: 100%;
    }

    .openModalButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:#036991;
    }

    :deep(.conditionalJson) {
        width: 100%;
    }

    :deep(.conditionalJson textarea) {
        width: 95%;
        min-height: 100px;
    }   

    :deep(.conditionalJson) {
        flex: 1 1 400px;
        display: flex;
        flex-direction: row; 
        align-items: center;
    }


    :deep(.conditionalJson div) {
        display: inline;
    }

    .row-header {
        font-weight: bold;
        border-bottom-style: double;
    }

    .row-data {
        border-bottom: solid 1px;
        padding: 10px 0px;
    }
    
    .row-data:nth-child(odd) {
        background-color: lightgray;
    }
    .row {
        display: flex;
        flex-direction: row;
        position: relative;
        width: 100%;
        padding: 10px 0px;

        & > div {
            margin: 0px 10px 0px 0px;
            box-sizing: border-box;
            border-right: solid 1px;
            padding-right: 10px;
        }

        & > div:first-child {
            border-right: none;
        }

        .grip {
            flex: 0 0 10px;
            cursor: grab;
        }

        .editConditions { 
            display: inline;
            background-color: unset;
            border: none;
            cursor: pointer;
            color: #036991;
            line-height: unset;
            margin-right: 10px;
        }

        .deleteButtonColumn {
            width: 30px; 
            display: flex; 
            flex-direction: row; 
            align-items: center; 
            border-right: none;

            & > div {
                cursor: pointer; 
                color: darkred;
            }
        }

        & a {
            text-decoration: none;
            color: #2c3e50;
        }

        .column-1x {
            flex: 0 0 100px;
        }

        .column-2x {
            flex: 0 0 250px;

        }

    }

</style>